// Praia Brisa — pousadas tranquilas, spa de praia, turismo litorâneo
// Sky blue + white + soft teal, calm and airy
module.exports = {
  effect: 'stars',
  colors: {
    main:            { light: '#f0f9ff', dark: '#071a2e' },
    card:            { light: '#dbeafe', dark: '#0f2d42' },
    surface:         { light: '#bfdbfe', dark: '#163d58' },
    action:          { light: '#0284c7', dark: '#38bdf8' },
    actionHover:     { light: '#0369a1', dark: '#7dd3fc' },
    textPrimary:     { light: '#071a2e', dark: '#f0f9ff' },
    textSecondary:   { light: '#0c2d4a', dark: '#bae6fd' },
    textMuted:       { light: '#2a6090', dark: '#7dd3fc' },
    textMutedSubtle: { light: '#4a80a8', dark: '#4a80a8' },
    border:          { light: '#93c5fd', dark: '#1e4a6a' },
    borderSubtle:    { light: '#bfdbfe', dark: '#132d42' },
    link:            { light: '#0284c7', dark: '#38bdf8' },
    linkBg:          { light: '#e0f2fe', dark: 'rgba(2,132,199,0.15)' },
    linkBorder:      { light: '#bae6fd', dark: '#075985' },
    linkHover:       { light: '#bae6fd', dark: 'rgba(2,132,199,0.28)' },
    inputBg:         { light: '#ffffff', dark: '#0f2d42' },
    inputBorder:     { light: '#93c5fd', dark: '#1e4a6a' },
    inputText:       { light: '#071a2e', dark: '#f0f9ff' },
    focusRing:       { light: '#0284c7', dark: '#7dd3fc' },
    overlay:         { light: 'rgba(7,26,46,0.5)', dark: 'rgba(0,0,0,0.78)' },
    confirm:         { light: '#4a80a8', dark: '#1e4a6a' },
    confirmHover:    { light: '#2a6090', dark: '#2a5a7a' },
    confirmText:     { light: '#ffffff', dark: '#f0f9ff' },
    confirmBg:       { light: '#f0f9ff', dark: '#0f2d42' },
    confirmBorder:   { light: '#bfdbfe', dark: '#1e4a6a' },
    success:         { light: '#047857', dark: '#34d399' },
    successHover:    { light: '#022c22', dark: '#10b981' },
    successBg:       { light: '#ecfdf5', dark: 'rgba(6,78,59,0.3)' },
    successText:     { light: '#10b981', dark: '#6ee7b7' },
    successBorder:   { light: '#a7f3d0', dark: '#065f46' },
    error:           { light: '#be123c', dark: '#fb7185' },
    errorHover:      { light: '#9f1239', dark: '#f43f5e' },
    errorBg:         { light: '#fff1f2', dark: 'rgba(136,19,55,0.3)' },
    errorText:       { light: '#f43f5e', dark: '#fda4af' },
    errorBorder:     { light: '#fecdd3', dark: '#9f1239' },
    info:            { light: '#0284c7', dark: '#0ea5e9' },
    infoHover:       { light: '#0369a1', dark: '#0284c7' },
    infoBg:          { light: '#f0f9ff', dark: 'rgba(2,132,199,0.2)' },
    infoText:        { light: '#0ea5e9', dark: '#38bdf8' },
    infoBorder:      { light: '#bae6fd', dark: '#075985' },
  },
  borderRadius: {
    card:      '36px',
    container: '22px',
    page:      '30px',
    button:    '9999px',
    input:     '16px',
    badge:     '10px',
    full:      '9999px',
  },
  borderWidth: {
    default: '1px',
    thick:   '2px',
    avatar:  '6px',
    device:  '8px',
  },
  textures: {
    main:    { light: '', dark: '', size: '0', blendLight: 'normal', blendDark: 'normal', opacityLight: 0, opacityDark: 0 },
    surface: { light: '', dark: '' },
    card:    { light: '', dark: '' },
  },
};
